/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Item
//   Details:    Item compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101873 25/06/19 JC  M01  Added IsAlwaysExpand to EmployeeNotices
// 101878 26/06/19 JC  M02  Added AttachedURL, AttachedURLDescription & HasAttachedURL to EmployeeNotices
// 101877 27/06/19 JC  M03  Changed pdf download to generic file download
// 102715 18/08/19 JC  M04  Added Contact item type
// 103015 10/09/19 JC  M05  Handle pay records without a tax year
// 103782 10/12/19 JC  M06  Added MyTraining
// 105066 06/01/20 JC  M07  Added font awesome
// 104762 28/02/20 JC  M08  Notices can now pass html
// 103839 06/04/20 JC  M09  React upgrade
// 106380 01/05/20 JC  M10  Just removed stamp datetime prop types check
// 108238 08/06/20 JC  M11  Re-wrote datetime components
// WI2224 27/01/23 JC  M12JC    Apply formatEnumString to request requestStatus
// WI3713 24/01/24 JC  M13JC    Expanded documents for data forms, moved isExpanded to Item in store
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { history } from '../history';
import { connect } from 'react-redux';
//M11 import DateLabel from './DateLabel'; //M11
//M11 import DateTimeLabel from './DateTimeLabel'; //M11
import DateTime from './DateTime'; //M11
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M11
import TileIcon from './TileIcon';
import FileDLView from './FileDLView'; //M03
//M07 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M07
import { printViewActions } from '../store/PrintView';
import { requestActions } from '../store/Request';
import { itemTypes } from '../constants/ItemTypes';
import TrainingQuestionsPanel from './TrainingQuestionsPanel'; //M06
import { noteTypes } from '../constants/NoteTypes'; //M08
import { utils } from '../utils/utils'; //M08
import './css/Item.css';

class Item extends Component {
	constructor(props) {
        super(props);
        //M13JC removed
  //      this.state = {
  //          //M01 - expanded now conditional based on the isAlwaysExpand property
  //          expanded: (this.props.item.isAlwaysExpand === true) //M01 was false 
		//};

        // attach handlers for item & button clicks
		this.handleItemClick = this.handleItemClick.bind(this);
		this.handleMarkAsRead = this.handleMarkAsRead.bind(this);
		this.handleMarkAsUnread = this.handleMarkAsUnread.bind(this);
        this.handlePrintView = this.handlePrintView.bind(this);
        this.handleAttachedURL = this.handleAttachedURL.bind(this); //M02
        this.handleEmailClick = this.handleEmailClick.bind(this); //M04
        this.handlePhoneClick = this.handlePhoneClick.bind(this); //M04
        this.handleStartTrainingClick = this.handleStartTrainingClick.bind(this); //M06
        this.handleStartTraining = this.handleStartTraining.bind(this); //M06
        this.handleDataFormClick = this.handleDataFormClick.bind(this); //M13JC
	}

    //item click event
	handleItemClick = event => {
		event.preventDefault();
		const { item } = this.props;
		if (item.itemType === itemTypes.request) {
			const { id } = item;
			this.props.setFromCalendar(undefined);
			history.push(`/myrequests/detail/${id}`);
		} else {

            //M13JC now in item state
			//this.setState({
			//	expanded: !this.state.expanded
			//});

            //M13JC pass to parent handle expanded/collapse function for item
            this.props.handleExpandedCollapse(item)
		}
	}

    //mark as read button click event
	handleMarkAsRead = event => {
		event.preventDefault();
		if (typeof this.props.markAsUnread === "function") {
			this.props.markAsRead(this.props.item);
		}
	}

    //mark as un-read button click event
	handleMarkAsUnread = event => {
		event.preventDefault();
		if (typeof this.props.markAsUnread === "function") {
			this.props.markAsUnread(this.props.item);
		}
	}

    //print view button event
	handlePrintView = event => {
		event.preventDefault();
		this.props.show(this.props.item);
    }

    //M02 handler for employee notice attached URL M06 or training
    handleAttachedURL = event => {
        event.preventDefault();
        //declare item as constant
        const { item } = this.props;
        //if the item has an attached URL
        if ((item.itemType === itemTypes.notice || item.itemType === itemTypes.training) && item.hasAttachedURL === true) { //M06
            //launch the attached URL in a new window
            window.open(item.attachedURL);
        }
    }

    //M04 handler for email click 
    handleEmailClick = event => {
        event.preventDefault();
        //get the item
        const { item } = this.props;
        //if a contact with an e-mail
        if (item.itemType === itemTypes.contact && item.hasEPContactEmail) {
            //launch a mailto to the e-mail adderss
            window.location.href = `mailto:${item.epContactEmail}`;
        }
    }

    //M04 handler for phone click 
    handlePhoneClick = event => {
        event.preventDefault();
        //get the item
        const { item } = this.props;
        //if a contact with a phone number
        if (item.itemType === itemTypes.contact && item.hasEPContactPhone) {
            //launch a tel to the phone
            window.location.href = `tel:${item.epContactPhone}`;
        }
    }

    //M06 handle start training click
    handleStartTrainingClick = event => {
        event.preventDefault();
        //declare item as constant
        const { item } = this.props;

        //pass to start training function for item
        this.props.startTraining(item);
    }

    //M06 handler for start training
    handleStartTraining(item) {
       
        //M06 if a training item & not completed, start training
        if (item.itemType === itemTypes.training && !item.isCompleted) {
            this.props.startTraining(this.props.item)
        }
    }

    //M13JC handler for data form click
    handleDataFormClick = event => {
        event.preventDefault();
        //declare item as constant
        const { item } = this.props;

        if (item.hasDataForm) {
            this.props.handleDataFormClick(item)
        }
    }

	render() {
        const { item, changeTrainingQuestion, answerTrainingQuestion, completeTraining } = this.props; //M06

		let title = "";
		let description = "";

        switch (item.itemType) {
            //M05 tax year may not be present
            case itemTypes.payRecord:                
                if (item.payYear) {
                    title = `Tax year ${item.payYear} ${item.payPeriod ? `period ${item.payPeriod}` : ""}`;
                } else {
                    title = `${item.payPeriod ? `Period ${item.payPeriod}` : ""}`;
                }
				
				description = item.typeName;
				break;
			case itemTypes.request:
				if (item.fromDate === item.toDate) {
                    title = <div><DateTime value={item.fromDate} dateTimeType={dateTimeTypes.date} disabled={true}
                    /> : {item.formattedSites}</div>; /*M11*/
				} else {
                    title = <div><DateTime value={item.fromDate} dateTimeType={dateTimeTypes.date} disabled={true}
                    /> to <DateTime value={item.toDate} dateTimeType={dateTimeTypes.date} disabled={true} /> : {item.formattedSites}</div>; /*M11*/
				}
				description = item.requestNote.length > 80 ? item.requestNote.substr(0, 80) + "..." : item.requestNote;
                break;
            //M04 contact item type
            case itemTypes.contact:
                title = item.epContactDescription;
                description = '';
                break;
			default:
				title = item.subject;
				description = item.typeName;
				break;
        }

        var displayDate = item.postedDate //M06 default to posted date
        if (item.itemType === itemTypes.payRecord) { displayDate = item.payDate; } //if pay record, use pay date
        if (item.itemType === itemTypes.training && item.isCompleted) { displayDate = item.completedStamp; } //M06 if completed training, use completed date
			
		const info = item.itemType === itemTypes.request
            ? utils.formatEnumString(item.requestStatus) //M12JC
            : <DateTime value={displayDate} dateTimeType={dateTimeTypes.date} disabled={true} />; /*M11*/

        //M06 determine if answering training
        const isAnsweringTraining = item && item.itemType === itemTypes.training && item.isAnsweringTraining && item.isAnsweringTraining === true;

        //M13JC determine if expanded
        const isExpanded = item && item.isExpanded === true;

		return (
			<div>
                <a className={`page-item ${isExpanded ? "expanded" : ""} `} onClick={this.handleItemClick}> {/*M13JC*/}
                    <div className="page-item-row">
                        {!this.props.simpleMode 
                            /* M04 don't show tile if in simple mode because no categories  */
                            ? <div className="tile-col">
                                <TileIcon borderColour={-1} backColour={item.backColour} textColour={item.textColour} tileText={item.tileText} />
                            </div>
                            : []
                        }
						<div className="text-col">
							<div className="float-left">
								<h5>{title}</h5>
                                <h6>{description}</h6>
							</div>
                            <div className="float-right">
                                {/*M06 if training & completed, display passed failed*/}
                                {item.itemType === itemTypes.training && item.isCompleted && item.isPassed
                                    ? <FontAwesomeIcon icon="check" className="lock-icon" style={{ color: 'green', fontSize: '25px' }}/>
                                    : []}
                                {item.itemType === itemTypes.training && item.isCompleted && !item.isPassed
                                    ? <FontAwesomeIcon icon="times" className="lock-icon" style={{ color: 'red', fontSize: '25px' }}/>
                                    : []}

                                {/*M13JC if document, display data form status*/}
                                {item.itemType === itemTypes.document && item.hasDataForm && !item.isStarted && !item.isAcknowledged
                                    //not started, not read
                                    ? <FontAwesomeIcon icon="exclamation" className="lock-icon" style={{ color: 'blue', fontSize: '25px' }} />
                                    : []}
                                {item.itemType === itemTypes.document && item.hasDataForm && !item.isStarted && item.isAcknowledged
                                    //not started, but read
                                    ? <FontAwesomeIcon icon="exclamation" className="lock-icon" style={{ color: 'red', fontSize: '25px' }} />
                                    : []}
                                {item.itemType === itemTypes.document && item.hasDataForm && item.isStarted && !item.isCompleted
                                    //started but not completed
                                    ? <FontAwesomeIcon icon="spinner" className="lock-icon" style={{ color: 'yellow', fontSize: '25px' }} />
                                    : []}
                                {item.itemType === itemTypes.document && item.hasDataForm && item.isStarted && item.isCompleted
                                    //completed     
                                    ? <FontAwesomeIcon icon="check" className="lock-icon" style={{ color: 'green', fontSize: '25px' }} />
                                    : []}



								{item.isSticky
                                    ? <FontAwesomeIcon icon="lock" className="lock-icon" />
									: []}
								{info}
							</div>
							<div className="clearfix" />
						</div>
						<div className="chevron-col">
                            {item.itemType === itemTypes.request
                                /* M08 replaced bsSize="large" with size="lg" */
                                ? <FontAwesomeIcon icon="chevron-right" size="lg" />
                                : <FontAwesomeIcon icon="chevron-down" size="lg" className={isExpanded ? "expanded" : ""} />} {/*M13JC*/}
						</div>
					</div>
				</a>
				{item.itemType !== itemTypes.request
                    ? <div className={`expander-container ${isExpanded ? "expanded" : ""}`}> {/*M13JC*/}
						<div className="expander-content">
							<div className="page-item-row">
								<div className="text-col">
                                    {(item.itemType === itemTypes.notice && item.noteType === noteTypes.text ) || (item.itemType === itemTypes.training && !isAnsweringTraining)
                                        /* M06 added training M08 notice only if text, added key */
                                        ? item.note.split('\n').map((i, k) => {
                                            return <span key={item.id + '_' + k}>{i}<br /></span>;
                                        }) 
                                        : []}
                                    {item.itemType === itemTypes.notice && item.noteType === noteTypes.html
                                        /* M08 notice only if html - set passed in html */
                                        ? <div dangerouslySetInnerHTML={utils.getSafeHTML(item.noteHTMLContent)} />
                                        : []}
									{item.itemType === itemTypes.request
										? <p>{item.requestNote}</p>
                                        : []}
                                    {item.itemType === itemTypes.contact
                                        /* M04 add contact comments M08 added key*/
                                        ? item.epContactNameAndComment.split('\n').map((i, k) => {
                                            return <span key={item.id + '_' + k}>{i}<br /></span>;
                                        })
                                        : []}
									<div className="float-left">
										{item.itemType === itemTypes.request
											? <p>{item.requestNote}</p>
											: []}


                                        {item.itemType === itemTypes.notice
                                            ? <button className="btn btn-default" onClick={this.handlePrintView}><FontAwesomeIcon icon="print" /> Print View</button>
                                            : []
                                        }

                                        {/*M13JC document file now optional*/}
                                        {(item.itemType === itemTypes.document && item.hasFile)|| item.itemType === itemTypes.payRecord ||
                                            (item.itemType === itemTypes.training && item.hasFile && !isAnsweringTraining)
                                            ?
                                            <div className="button-group float-left" /*M13 JC add the div for better layout*/> 
                                                <FileDLView
                                                    itemType={item.itemType}
                                                    /* M06 removed id={item.id} */
                                                    item={item}
                                                    startTraining={this.handleStartTraining} /* M03 */
                                                    fileextension={item.fileextension} /* M03 changed from PdfDLview*/
                                                />
                                            </div>
                                        : []
                                        }

                                        {item.hasDataForm /*M13JC has data form? */
                                            ?
                                            < div className="button-group float-left">
                                                <button className="btn btn-default btn-dftleftpadding" onClick={this.handleDataFormClick} >Open Form</button>
                                            </div>
                                        : []}
                                                                            
                                        {item.hasAttachedURL === true && !isAnsweringTraining
                                            /* M02 if the item has an attched URL, add a button for handle attached URL M04 renamed css*/
                                            ? <button className="btn btn-default btn-dftleftpadding" onClick={this.handleAttachedURL}><FontAwesomeIcon icon="globe-americas" /> {item.attachedURLDescription}</button>
                                            : []}

                                        {item.itemType === itemTypes.training && item.hasAttachedURL && !item.isCompleted && !isAnsweringTraining
                                            /* M06 if training, has attached url not completed and not answering training, show start training button*/
                                            ? <button className="btn btn-default btn-dftleftpadding" onClick={this.handleStartTrainingClick}><FontAwesomeIcon icon="graduation-cap" /> Q&A</button>
                                            : []}


                                        {item.itemType === itemTypes.contact && item.hasEPContactEmail
                                            /* M04 if a contact and has a contact e-mail*/
                                            ? <button className="btn btn-default btn-dftleftpadding" onClick={this.handleEmailClick}><FontAwesomeIcon icon="envelope" /> {item.epContactEmail}</button>
                                            : []
                                        }

                                        {item.itemType === itemTypes.contact && item.hasEPContactPhone
                                            /* M04 if a contact and has a contact phone*/
                                            ? <button className="btn btn-default btn-dftleftpadding" onClick={this.handlePhoneClick}><FontAwesomeIcon icon="envelope" /> {item.epContactPhone}</button>
                                            : []
                                        }

                                    </div>

                                    {item.itemType !== itemTypes.contact && item.itemType !== itemTypes.training ?
                                        /* M01 contacts can't be acknowledged so don't add acknowledge info  M06 also training*/
                                        <div className="float-right">
                                            {item.isAcknowledged
                                                ? <span className="ack-text">Read on <DateTime
                                                    value={item.acknowledgedStamp} dateTimeType={dateTimeTypes.dateTime} disabled={true}
                                                /></span> /*M11*/
                                                : []}
                                            {item.isAcknowledged
                                                ? <button className="btn btn-default" onClick={this.handleMarkAsUnread}>Mark as unread</button>
                                                : <button className="btn btn-default" onClick={this.handleMarkAsRead}>Mark as read</button>
                                            }
                                        </div>
                                        : []
                                    }


                                    {isAnsweringTraining ?
                                        /* M06 have we started training? */
                                        <TrainingQuestionsPanel
                                            item={item}
                                            changeTrainingQuestion={changeTrainingQuestion} /*M06*/
                                            answerTrainingQuestion={answerTrainingQuestion} /*M06*/
                                            completeTraining={completeTraining} /*M06*/
                                        />
                                        : []
                                    }

									<div className="clearfix" />
								</div>
							</div>
						</div>
					</div>
					: []}
			</div>
		);
	}
}

Item.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.number.isRequired,
		backColour: PropTypes.number,//M04 no longer required .isRequired,
		textColour: PropTypes.number.isRequired,
		isSticky: PropTypes.bool,
		tileText: PropTypes.string.isRequired,
		subject: PropTypes.string,
		typeName: PropTypes.string,
        //M10 postedDate: PropTypes.instanceOf(Date), //M09 was PropTypes.DateTime,
		isAcknowledged: PropTypes.bool,
        //M10 acknowledgedStamp: PropTypes.instanceOf(Date), //M09 was PropTypes.DateTime,
		setAcknowledged: PropTypes.func,
		printView: PropTypes.func,
		note: PropTypes.string,
        itemType: PropTypes.oneOf([itemTypes.notice, itemTypes.document, itemTypes.payRecord, itemTypes.request, itemTypes.contact, itemTypes.training]), //M04
        isAlwaysExpand: PropTypes.bool, //M01
        attachedURL: PropTypes.string, //M02
        hasAttachedURL: PropTypes.bool, //M02
        attachedURLDescription: PropTypes.string, //M02
        itemExtension: PropTypes.string //M03
	}),
	markAsRead: PropTypes.func.isRequired,
    markAsUnread: PropTypes.func.isRequired,
    startTraining: PropTypes.func.isRequired, //M06
    changeTrainingQuestion: PropTypes.func.isRequired //M06
};


export default connect(
	state => state,
	dispatch => bindActionCreators({ ...printViewActions, ...requestActions }, dispatch)
)(Item);
